/**
 * ELECTRO-AUTOMOTRIZ — Scroll Reveal Animations
 * Lightweight IntersectionObserver-based reveal system.
 * No dependencies. Works with ea-custom.css reveal classes.
 */
(function () {
  'use strict';

  var SELECTORS = '.ea-reveal, .ea-reveal-left, .ea-reveal-right, .ea-reveal-scale';

  /* Stagger child elements of .ea-stagger containers */
  function applyStagger() {
    document.querySelectorAll('.ea-stagger').forEach(function (container) {
      Array.from(container.children).forEach(function (child, index) {
        if (!child.classList.contains('ea-reveal') &&
            !child.classList.contains('ea-reveal-left') &&
            !child.classList.contains('ea-reveal-right') &&
            !child.classList.contains('ea-reveal-scale')) {
          child.classList.add('ea-reveal');
        }
        child.style.transitionDelay = (index * 0.08) + 's';
      });
    });
  }

  /* Observe all reveal elements */
  function initReveal() {
    var elements = document.querySelectorAll(SELECTORS);
    if (!elements.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.10,
        rootMargin: '0px 0px -48px 0px'
      }
    );

    elements.forEach(function (el) { observer.observe(el); });
  }

  /* Subtle parallax on hero slides */
  function initHeroParallax() {
    var hero = document.querySelector('.slideshow-section');
    if (!hero || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          var scrolled = window.scrollY;
          var media = hero.querySelectorAll('.media--slide');
          media.forEach(function (el) {
            el.style.transform = 'translateY(' + (scrolled * 0.25) + 'px)';
          });
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  /* Init on DOM ready */
  function init() {
    applyStagger();
    initReveal();
    initHeroParallax();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Re-run on Shopify section re-renders */
  document.addEventListener('shopify:section:load', function () {
    applyStagger();
    initReveal();
  });
})();
